exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-log[data-v-6762346d]{\n    position: relative;\n    margin: 10% auto;\n    max-height: 50em;\n    padding: 30px;\n    max-width: 60em;\n    border-radius: 4px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.16);\n    background-color: #FAFAFA;\n    overflow-y: auto;\n}\n.avoid-page-break[data-v-6762346d] {\n  page-break-inside: avoid;\n}\n", ""]);

// exports
